import secureLs from '@/libs/secureLs'

const komcardsGuard = (to, from, next) => {
  const userData = secureLs.getItem('userData')
  if (userData && userData.is_komcards === 0) {
    return next({ path: '/' })
  }
  return next()
}

export default [
  {
    path: '/komcards',
    name: 'komcards',
    component: () => import('@/views/pages/komcard/List.vue'),
    meta: {
      resource: 'KartuKomcards',
      action: 'manage',
    },
    beforeEnter: komcardsGuard,
  },

  {
    path: '/komcards/add',
    name: 'komcards-add',
    component: () => import('@/views/pages/komcard/Add.vue'),
    meta: {
      resource: 'KartuKomcards',
      action: 'manage',
      navActiveLink: 'komcards',
    },
    beforeEnter: komcardsGuard,
  },
  {
    path: '/komcards/:id',
    name: 'card-detail',
    component: () => import('@/views/pages/komcard/Detail.vue'),
    meta: {
      resource: 'KartuKomcards',
      action: 'manage',
      navActiveLink: 'komcards',
    },
    beforeEnter: komcardsGuard,
  },
]
